import type { ComponentType } from "react";
import { GenericWidget } from "./GenericWidget";
import { AgentListWidget } from "./AgentListWidget";
import { SystemHealthWidget } from "./SystemHealthWidget";
import { DataTableWidget } from "./DataTableWidget";
import { HtmlWidget } from "./HtmlWidget";

export const WIDGET_RENDERERS: Record<string, ComponentType<{ data: Record<string, unknown> }>> = {
  "generic": GenericWidget,
  "agent-list": AgentListWidget,
  "system-health": SystemHealthWidget,
  "data-table": DataTableWidget,
  "html": HtmlWidget,
};
